import { Widget } from '../Widget';
import { $ } from '../../../vendor/jquery';
import { WidgetType } from '../types';

import {
    CustomHtmlWidgetConfigurationDetails,
    CustomHtmlWidgetConfiguration,
    ZodCustomHtmlWidgetConfigurationDetails,
} from './types';
import { Log } from '../../AuxillaryService/Log';
import { pushReceiver } from '../../MessagingClient/instance';

export class CustomHtmlWidget extends Widget {
    type: WidgetType.CUSTOM_HTML = WidgetType.CUSTOM_HTML;
    declare config: CustomHtmlWidgetConfigurationDetails;

    constructor(widgetConfiguration: CustomHtmlWidgetConfiguration, zoneId: number) {
        super(widgetConfiguration, zoneId);
    }

    protected validateConfigurationDetails(
        maybeCustomHtmlWidgetConfigurationDetails: CustomHtmlWidgetConfigurationDetails
    ): CustomHtmlWidgetConfigurationDetails {
        return ZodCustomHtmlWidgetConfigurationDetails.parse(
            maybeCustomHtmlWidgetConfigurationDetails
        );
    }

    /**
     * @inheritdoc
     */
    async getReadyForDisplay(): Promise<void> {
        if (!this.config.html) {
            this.hasContentToPlay = false;
        } else {
            this.hasContentToPlay = true;
            $(this.wrapperElement).html(this.config.html);
        }
    }

    /**
     * Subscribe the widget to message from Mercury and add a listener
     * @listens MessagingClient#custom-html-update
     */
    static subscribeToCustomHtmlMessage(
        identifier: string,
        listener: (data: unknown) => void
    ): void {
        pushReceiver().addListener('custom-html-update', (event) => {
            if (event.detail.identifier === identifier) {
                listener.call(this, event.detail.data);
            }
        });

        pushReceiver()
            .subscribeToCustomHtml(identifier)
            .then(() => {
                Log.Info(
                    'CustomHtml Widget Subscribed. identifier: ' + identifier,
                    null,
                    __fileline
                );
            })
            .catch((error: Error) => {
                //failure!
                Log.Error('Failed to subscribe to channel ' + identifier, null, __fileline, error);
            });
    }
}
